import { useEffect } from 'react';
import { Button } from 'framework/ui/mui-builder';
import { SubmitButton } from 'framework/ui/ui-builder';
import { useFormContext } from 'framework/form';
import decisionFormValidationSchema from './decisionFormValidationSchema';
import DecisionMakerEmployeeInput from '../../input/DecisionMakerEmployeeInput';
import { Box } from '@mui/material';

interface DecisionStageFormProps {
  handleCancelClick: () => void;
}

const DecisionStageForm = ({ handleCancelClick }: DecisionStageFormProps) => {
  const { submitForm, isSubmitEnabled, isLoadingArtifact, setValidationSchemaAction } = useFormContext();

  useEffect(() => {
    if (setValidationSchemaAction) {
      setValidationSchemaAction(decisionFormValidationSchema);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <DecisionMakerEmployeeInput label="Decision Maker" source="decisionMakerAlias" isRequired />
      <Box display="flex" gap={1.25}>
        <SubmitButton
          key="submit-modal-btn"
          onClick={submitForm}
          isLoading={!isSubmitEnabled}
          disabled={isLoadingArtifact}
        />
        <Button
          variant="outlined"
          key="cancel-modal-btn"
          onClick={handleCancelClick}
          disabled={!isSubmitEnabled || isLoadingArtifact}
        >
          Cancel
        </Button>
      </Box>
    </>
  );
};

export default DecisionStageForm;
